import styled from 'styled-components';

export const MainContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: ${({ isTakingScreenshot, realHeight, shouldDisplayHeader }) =>
    isTakingScreenshot
      ? 'auto'
      : `calc(${realHeight} - ${shouldDisplayHeader ? '61px' : '0px'})`};
  justify-content: flex-end;
`;

export const Scrollable = styled.div`
  position: relative;
  overflow-y: auto;
  flex-grow: 2;
  display: flex;
  flex-direction: column;
`;

export const Background = styled.div`
  background-color: ${({ theme }) => theme.cardBackgroundColor};
  font-family: ${({ theme }) => theme.fontFamily};
`;
